<!--
@author Dy
@createDate 2017/11/22 19:57
@description 国家省市区联动组件
gutter|设置各级别选择器之间的距离，单位px
level|要显示的级别，如设为2则显示县/区，即3级，级别可设为0、1、2、(暂未开发第四级别)
data-type|返回数据的类型，'all':城市编码和名称，'code':只返回编码，'name':只返回名称 (暂时只支持code,其他的在开发中)
searchable|是否可搜索，添加该属性则点击选择器后可输入名称搜索|Boolean|false
size|选择器尺寸，该属性同iview组件select的size属性，可选值为small，large
placeholder|选择器未选择时显示的占位字符,若为字符串，则各级别选择器均使用该作为占位字符，若为数组，根据数组对应位置的字符串设置选择器占位字符，若数组元素少于级别数，
  缺省的则设为默认数组中对应的占位字符['区域', '市', '县/区', '乡/镇/街']
not-found-text|无数据时显示的文字提示，规则同placeholder属性
disabled|设置禁用整个级联选择器或某个级别的选择器，可只写``disabled``，也可写``:disabled="true"``或``"false"``，
  或传入一个数组，如禁用二级和四级选择器则为``[1, 3]``，也可传入数值指定从指定级别开始禁用
-->

<template>
  <div class="area-cls">
    <Row :gutter="gutterNum">
      <i-col :span="firstSpan" v-if="show(0)">
        <Cascader
          clearable
          transfer
          v-model="currArea"
          :data="areaList"
          :filterable="searchable"
          :change-on-select="isChange"
          :render-format="format"
          :placeholder="phHandled(0)"
          :not-found-text="ndsHandled(0)"
          :disabled="disabled === undefined ? false : disHandled(0)">
        </Cascader>
      </i-col>
      <i-col :span="span" v-if="show(1)">
        <Cascader
          clearable
          transfer
          ref="city"
          v-model="currCit"
          :data="cityList"
          :change-on-select="isChange"
          :filterable="searchable"
          :placeholder="phHandled(1)"
          :not-found-text="ndsHandled(1)"
          :disabled="disabled === undefined ? false : disHandled(1)"
          style="width:100%">
        </Cascader>
      </i-col>
      <i-col :span="span" v-if="show(2)">
        <Cascader
          clearable
          transfer
          ref="coun"
          v-model="currCou"
          :data="counList"
          :filterable="searchable"
          :change-on-select="isChange"
          :placeholder="phHandled(2)"
          :not-found-text="ndsHandled(2)"
          :disabled="disabled === undefined ? false : disHandled(2)"
          style="width:100%">
        </Cascader>
      </i-col>
    </Row>
    <slot></slot>
  </div>
</template>

<script>
  import util from './areaUtil'
  import { http } from '@/api/http'

  //const areaLinkageArr = util.levelArr
  export default {
    name: 'NewAreaSelector',
    data () {
      return {
        currArea: [],
        currCit: [],
        currCou: [],
        areaList: [],
        cityList: [],
        counList: [],
        defaultPlaceholder: ['国家-省/州', '市', '县/区', '乡/镇/街'],
        defaultNotFoundText: ['无匹配', '无匹配市', '无匹配县/区', '无匹配乡/镇/街'],
        echoShow: false
      }
    },
    props: {
      gutter: {
        type: [String, Number],
        default: 5
      },
      //要和util中一致
      level: {
        type: [String, Number],
        default: 2,
        validator: val => {
          return util.oneOf(parseInt(val, 10), util.levelArr)
        }
      },
      value: {
        type: Array
      },
      searchable: {
        type: Boolean,
        default: false
      },
      dataType: {
        type: String,
        default: 'all',
        validator: (val) => {
          return util.oneOf(val, ['all', 'code', 'name'])
        }
      },
      placeholder: {
        type: [Array, String],
        default () {
          return this.defaultPlaceholder
        }
      },
      notFoundText: {
        type: [String, Array],
        default () {
          return this.defaultNotFoundText
        }
      },
      disabled: {
        type: [Boolean, Array, Number],
        default: false
      },
      autoLoad: {
        type: Boolean,
        default: true
      },
    },
    computed: {
      gutterNum () {
        if (typeof this.gutter === 'number') {
          return this.gutter
        } else {
          return parseInt(this.gutter, 10)
        }
      },
      showLevel () {
        return parseInt(this.level, 10)
      },
      firstSpan () {
        if (this.showLevel === 0) {
          return 17
        }
        return 13
      },
      span () {
        if (util.oneOf(this.showLevel, util.levelArr)) {
          return 10 / this.showLevel
        }
      },
      isChange () {
        return true
      }
    },
    watch: {
      autoLoad (val) {
        if (val) {
          this.dataInit()
        }
      },
      currArea (area) {
        if (area) {
          this.updateNextSelector('cityList', area, 0)
        }
      },
      currCit (city) {
        if (city) {
          this.updateNextSelector('counList', city, 1)
        }
      },
      currCou (coun) {
        if (coun) {
          this.updateNextSelector('streList', coun, 2)
        }
      },
//      currStr (str) {
//        this.streIndex = util.getIndex(this.streList, str)
//        if (str) {
//          this.returnRes(3)
//        }
//      }
      value (val) {
//        this.echoShow = true
        if (Array.isArray(val)) {
          if (val.length === 0) {
            this.currArea = []
          } else if (val.length === 1) {
            this.currArea = [val[0]]
          } else {
            this.currArea = [val[0], val[1]]
          }
        }
      }
    },
    methods: {
      //初始化
      dataInit () {
        if (this.autoLoad) {
          const version = localStorage.getItem('districtsVersionNo2') === null ? '' : localStorage.getItem('districtsVersionNo2')
          if (localStorage.getItem('all2')) {
            let all2 = JSON.parse(localStorage.getItem('all2'))
            if (all2 && all2.length > 0){
              all2.forEach((item)=>{
                if (item.value !== 'CN' && item.value !== 'HK' && item.value !== 'TW' && item.value !== 'MO') {
                  this.areaList.push(item)
                }
              })
            }
          } else {
            this.$store.dispatch('districtsTree', {version}).then(() => {
              // this.areaList = JSON.parse(localStorage.getItem('all2'))
              if (!JSON.parse(localStorage.getItem('all2'))) {
                this.areaList = []
              } else {
                let all2 = JSON.parse(localStorage.getItem('all2'))
                if (all2 && all2.length > 0){
                  all2.forEach((item)=>{
                    if (item.value !== 'CN' && item.value !== 'HK' && item.value !== 'TW' && item.value !== 'MO') {
                      this.areaList.push(item)
                    }
                  })
                }
              }
            })
          }
        }
      },
      //触发下一个节点
      updateNextSelector (nextList, next, level) {
        if (level <= this.showLevel) {
          //区别是选的第一个
          if (next.length === 0) {
            this[nextList] = []
            if (level === 0) {
              this.currCit = []
            } else if (level === 1) {
              this.currCou = []
            }
          } else if (next.length > 1 && level === 0) {
            this.loadData(nextList, next[1], level)
          } else if (next.length === 1 && level !== 0) {
            this.loadData(nextList, next[0], level)
          }
          this.returnResArr(level)
        }
      },
      loadData (nextList, districtCode, level) {
        this.$store
          .dispatch("districtsTreeSubset", { districtCode  })
          .then(data => {
            if (!data && !data.districtTreeSubset) {
              this[nextList] = data.districtTreeSubset
              this.$nextTick(() => {
                if (Array.isArray(this.value) && this.value.length > 0) {
                  if (level === 0) {
                    if (this.value[2]) {
                      this.currCit = [this.value[2]]
                    }
                  } else if (level === 1) {
                    if (this.value[3]) {
                      this.currCou = [this.value[3]]
                    }
                  }
                } else {
                  if (level === 0) {
                    this.currCit = []
                  } else if (level === 1) {
                    this.currCou = []
                  }
                }
              })
            }
          })
      },
      //返回到父组件的值
      returnResArr (level) {
        let res = []
        if (level !== undefined) {
          this.currArea.forEach(area => {
            if (area) {
              res.push(area)
            }
          })
          if (level === 1) {
            if (this.currCit.length === 1) {
              res.push(this.currCit[0])
            }
          } else if (level === 2) {
            if (this.currCit.length === 1) {
              res.push(this.currCit[0])
            }
            if (this.currCou.length === 1) {
              res.push(this.currCou[0])
            }
          }
        }
//        if (!this.echoShow) {
//          this.$emit('input', res)
//        }
        this.$emit('on-change', res)
      },
      show (level) {
        return level <= this.showLevel
      },
      handleInput () {
        //TODO 暂时不做功能
      },

      hasChange () {
        //TODO 单个选择触发
      },
      phHandled (level) {
        if (typeof this.placeholder === 'string' && this.placeholder !== '') {
          return this.placeholder
        } else {
          if (this.placeholder && this.placeholder[level]) {
            return this.placeholder[level]
          } else {
            return this.defaultPlaceholder[level]
          }
        }
      },
      ndsHandled (index) {
        if (typeof this.notFoundText === 'string' && this.notFoundText !== '') {
          return this.notFoundText
        } else {
          if (!this.notFoundText) {
            return this.defaultNotFoundText[index]
          } else {
            if (this.notFoundText[index]) {
              return this.notFoundText[index]
            } else {
              return this.defaultNotFoundText[index]
            }
          }
        }
      },
      disHandled (level) {
        if (typeof this.disabled === 'number') {
          if (util.oneOf(this.disabled, util.levelArr)) {
            return level >= this.disabled
          }
        } else if (Array.isArray(this.disabled)) {
          let i = 0
          let isDis = false
          while (this.disabled[i]) {
            if (this.disabled[i] === level) {
              isDis = true
              break
            }
            i++
          }
          return isDis
        } else {
          return this.disabled
        }
      },
      format (labels, selectedData) {
        return this.format2(labels, selectedData, '-')
      },
      format2 (labels, selectedData, symbol) {  //格式化需要的模板字符串
        const index = labels.length - 1
        const data = selectedData[index] || false
        if (data) {
          return labels.join(symbol)
        }
        return labels[index]
      },
    },
    mounted () {
      this.dataInit()
      this.$nextTick(() => {
        if (Array.isArray(this.value)) {
          if (this.value.length === 0) {
            this.currArea = []
          } else if (this.value.length === 1) {
            this.currArea = [this.value[0]]
          } else if (this.value.length === 2) {
            this.currArea = [this.value[0], this.value[1]]
          }
        }
      })
    }
  }
</script>
<style type="text/scss" scoped>
  .ivu-col-span-13 {
    width: 45.3%;
  }

  .ivu-col-span-17 {
    width: 99%;
  }

  .ivu-col-span-10 {
    width: 53.6%;
  }

  .ivu-col-span-5 {
    width: 26.8%;
  }
</style>



// WEBPACK FOOTER //
// NewAreaSelector.vue?b9e20cd0